import { Dispatch, SetStateAction, useEffect, useState } from 'react';
// import {
//   FlexBetween,
//   FlexJustifyCenter,
//   HubLengthMessage
// } from '../../../styles/stylesStyled';

import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { FlexJustifyCenter, HubLengthMessage } from '../../styles/stylesStyled';
import { AnimatedItem } from '../../components/animation/AnimatedItem';
import { AnimatedDashboard, AnimatedTab, Button } from '../../components';
import { formatUSD, formatUSDNoDecimals } from '../../helpers/helperFunctions';
import { InvoiceHeader, Invoices } from './OrdersStyled';
import { MyOrderListModel, OrderItem } from '../Marketplace/Maeketplace.types';
import { useAppSelector } from '../../app/hooks';
import { useParams } from 'react-router-dom';
import { getOrders } from '../../slices/orders-slice';
import { AsyncThunkAction } from '@reduxjs/toolkit';

import { useDispatch } from 'react-redux';

// import { Desktop, Mobile } from '../../../App';
// import { AnimatedItem } from '../../../components/animation/AnimatedItem';
// import { AnimatedTab } from '../../../components/animation/AnimatedTab';
// import { USDT, formatUSD } from '../../../helpers/helperFunctions';
// import { Button } from '../../../styles/GlobalComponents';
// import { InvoiceHeader, Invoices, InvoicesMobile } from '../AccountingStyled';

// interface InvoicesPageType {
//   orderItems: OrderItem[];
// }

export const OrderItems = () => {
  const { id } = useParams<{ id: string }>();

  const { orders } = useAppSelector((state) => state.orders);
  const filteredOrder = orders.find((order) => order.id === Number(id));
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  return (
    <AnimatedDashboard zoom>
      <div style={{ overflowX: 'auto', width: '100%' }}>
        <div style={{ minWidth: 800 }}>
          <InvoiceHeader>
            <div style={{ width: '15%' }}>Order Id</div>
            <div style={{ width: '15%' }}>Product Id</div>
            <div style={{ width: '15%' }}>Name</div>
            <div style={{ width: '15%' }}>Price</div>
            <div style={{ width: '15%' }}>Subscription Id</div>
            <div style={{ width: '15%' }}>Subscription Status</div>
            <div style={{ width: '15%' }}>Sub Billing Interval</div>
            {/* <div style={{ width: '20%' }}>Date Next Billing</div> */}
          </InvoiceHeader>
          {filteredOrder?.orderItems?.map((inv: OrderItem, i: number) => {
            return (
              <AnimatedItem key={i} index={i}>
                <Invoices>
                  <div style={{ width: '15%' }}>{inv.id}</div>
                  <div style={{ width: '15%' }}>{inv.productId}</div>
                  <div style={{ width: '15%' }}>{inv.name}</div>
                  <div style={{ width: '15%' }}>
                    {formatUSDNoDecimals(inv.price)}
                  </div>
                  <div style={{ width: '15%' }}>{inv.subscription?.id}</div>
                  <div style={{ width: '15%' }}>{inv.subscription?.status}</div>
                  <div style={{ width: '15%' }}>
                    {inv.subscription?.billingInterval}
                  </div>
                  {/* <div style={{ width: '20%' }}>
                    {inv?.subscription?.dateNextBilling &&
                      moment
                        .utc(inv?.subscription?.dateNextBilling)
                        .format('DD/MM/YY')}
                  </div> */}
                </Invoices>
              </AnimatedItem>
            );
          })}
        </div>
      </div>
    </AnimatedDashboard>
  );
};
